import { ChangeDetectionStrategy, Component, EventEmitter, HostListener, input, Output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { GalleryDto, GalleryTheme, Section } from '@nusign/picflow-backend-types';
import { ScreenSizes } from '../../../classes/screen-sizes.class';
import { ContextMenuComponent } from '../../../shared/components/context-menu/context-menu.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { TooltipDirective } from '../../../shared/directives/tooltip.directive';
import { CommonSectionSettingsComponent } from '../common-section-settings/common-section-settings.component';
import { EditSectionTextComponent } from '../edit-section-text/edit-section-text.component';
import { SectionContainerComponent } from '../section-container/section-container.component';

@Component({
  selector: 'app-edit-text-section',
  templateUrl: './edit-text-section.component.html',
  styleUrls: ['./edit-text-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    SectionContainerComponent,
    ContextMenuComponent,
    ButtonDirective,
    SvgComponent,
    FormsModule,
    TooltipDirective,
    CommonSectionSettingsComponent,
    EditSectionTextComponent,
  ],
})
export class EditTextSectionComponent {
  readonly sectionIndex = input<number>(undefined);
  readonly section = input<Section>(undefined);
  readonly gallery = input<GalleryDto>(undefined);
  readonly sections = input<Section[]>(undefined);
  readonly theme = input.required<GalleryTheme>();
  readonly galleryPermissions = input.required<GalleryDto['permissions']>();
  readonly darkBackground = input<boolean>(undefined);
  @Output() addSection: EventEmitter<number> = new EventEmitter();
  isDesktop = signal(ScreenSizes.screenSize() === 'desktop');

  @HostListener('window:resize', ['$event']) winResize() {
    this.isDesktop.set(ScreenSizes.screenSize() === 'desktop');
  }
}
